import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    value: '+400,000',
    label: 'uruguayos afectados'
  }, {
    value: '6',
    label: 'Tomos listos para usar'
  }, {
    value: '6',
    label: 'Bonos incluidos'
  }, {
    value: '4.9/5',
    label: 'calificación',
    isRating: true
  }];
  const testimonials = [{
    initials: 'JM',
    text: '"Tenía una deuda de $68,000 pesos. Negocié la quita y terminé pagando $12,000. El guión del Tomo 5 me ahorra horas de angustia cada semana."',
    author: 'Jorge M., 43 años — Canelones'
  }, {
    initials: 'AL',
    text: '"El Derecho al Olvido por fin se entiende. Las cartas modelo son el hit de todo el proceso. 6 semanas y el registro desapareció del sistema."',
    author: 'Ana L., 38 años — Montevideo'
  }, {
    initials: 'RV',
    text: '"Mis deudas de más de 5 años por fin tienen solución. El Tomo 2 vale cada peso que costó el sistema."',
    author: 'Roberto V., 51 años — Salto'
  }];
  return <section className="py-10 md:py-12 px-4 bg-brand-light border-y border-gold/10" data-id="element-270">
      <div className="max-w-4xl mx-auto" data-id="element-271">
        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16" data-id="element-272">
          {stats.map((stat, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="text-center" data-id="element-273">
              <div className="text-3xl md:text-4xl font-black text-gold-gradient mb-2" data-id="element-274">
                {stat.value}
              </div>
              <div className="text-sm text-cream/80 font-medium leading-tight" data-id="element-275">
                {stat.label}
                {stat.isRating && <div className="flex justify-center mt-1" data-id="element-276">
                    {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 text-gold fill-gold" data-id="element-277" />)}
                  </div>}
              </div>
            </motion.div>)}
        </div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-6" data-id="element-278">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.15
        }} className="bg-brand-dark border border-gold/20 rounded-2xl p-6 relative shadow-lg" data-id="element-279">
              <div className="flex items-center gap-3 mb-4" data-id="element-280">
                <div className="w-10 h-10 rounded-full bg-gold-gradient flex items-center justify-center text-brand-dark font-bold text-sm shadow-gold-glow" data-id="element-281">
                  {t.initials}
                </div>
                <div className="flex" data-id="element-282">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 text-gold fill-gold" data-id="element-283" />)}
                </div>
              </div>
              <p className="text-cream/90 italic mb-4 text-sm leading-relaxed" data-id="element-284">
                {t.text}
              </p>
              <p className="text-gold/80 text-xs font-semibold uppercase tracking-wider" data-id="element-285">
                {t.author}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}